import { useEffect, useState } from 'react';
import { useTracking } from '@podiumhq/tracking';

import { useCreditCardContext } from 'contexts/CreditCardDetailsContextProvider';
import { stripeErrorMessage } from 'lib/creditCardValidators';
import { getEmptyErrorMessage } from 'lib/fieldValidation';

const useCreditCardDetailsInputError = (
  id,
  shouldUpdateInvalid,
  zipCodeText
) => {
  const { creditCardFields = {}, updateCreditCardField } =
    useCreditCardContext() || {};
  const { isEmpty, shouldDisplayError } = creditCardFields[id] || {};

  const [inputErrorMessage, setInputErrorMessage] = useState(null);
  const { trackEvent } = useTracking();

  const onInputChange = (event = {}) => {
    const { elementType, empty, target } = event;
    const isEmpty = elementType ? empty : !target?.value;

    updateCreditCardField &&
      updateCreditCardField(id, {
        ...creditCardFields[id],
        isEmpty,
        shouldDisplayError: false,
      });

    setInputErrorMessage(stripeErrorMessage(event?.error) || null);
  };

  useEffect(() => {
    // set input as invalid if errorMessage exists
    if (shouldUpdateInvalid && updateCreditCardField && !isEmpty) {
      updateCreditCardField(id, {
        ...creditCardFields[id],
        isInvalid: !!inputErrorMessage,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inputErrorMessage]);

  useEffect(() => {
    // display empty error, set from purchase button
    if (shouldDisplayError && isEmpty && !inputErrorMessage) {
      setInputErrorMessage(getEmptyErrorMessage(id, zipCodeText));
      trackEvent(`trials.startTrial.fieldError`, { field: id });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inputErrorMessage, isEmpty, shouldDisplayError]);

  return { onInputChange, inputErrorMessage };
};

export default useCreditCardDetailsInputError;
